import { PaymentMethodName } from 'data/__generated__';

// Libellés FR des moyens de paiement d'une transaction, partagés par le détail transaction et la
// consommation d'une organisation.
const PAYMENT_METHOD_LABELS: Record<PaymentMethodName, string> = {
    [PaymentMethodName.CreditCardPaymentMethod]: 'Carte bancaire',
    [PaymentMethodName.CreditPaymentMethod]: 'Crédits',
    [PaymentMethodName.MealVoucherPaymentMethod]: 'Titre restaurant',
    [PaymentMethodName.MealPlanPaymentMethod]: 'Réduction formule',
    [PaymentMethodName.OrganizationCardPaymentMethod]: 'Badge Pro',
    [PaymentMethodName.RitualPaymentMethod]: 'Rituel',
    [PaymentMethodName.SubventionPaymentMethod]: 'Subvention',
    [PaymentMethodName.ThirdPartyPaymentMethod]: 'Paiement externe',
};

export function getPaymentMethodLabel(paymentMethodName?: string | null): string {
    if (!paymentMethodName || !(paymentMethodName in PAYMENT_METHOD_LABELS)) {
        return 'Moyen de paiement inconnu';
    }
    return PAYMENT_METHOD_LABELS[paymentMethodName as PaymentMethodName];
}
